import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UserSafetyOperations } from "../../shared-components";
import { deleteConversation } from "./Conversation/reducers";
import { useTrans } from "../../hooks";

function ThreadControlUI({
  isLoading,
  activeThread,
  isMutedByCurrentUser,
  isBlockedByCurrentUser,
  deleteConversation,
  privateMessagePermissions
}) {
  const { trans } = useTrans();

  function onDeleteConversation() {
    if (
      confirm(trans("Delete all messages between you and %s?", activeThread))
    ) {
      deleteConversation(activeThread).then(() => {
        if (window.location.pathname === "/inbox") {
          window.location.reload();
        } else {
          window.app.router.navigate("/inbox", { trigger: true });
        }
      });
    }
  }

  return (
    <div>
      {!isLoading && (
        <UserSafetyOperations
          username={activeThread}
          isMutedByCurrentUser={isMutedByCurrentUser}
          isBlockedByCurrentUser={isBlockedByCurrentUser}
          onDeleteConversation={onDeleteConversation}
          showModerationOptions={
            typeof privateMessagePermissions?.canSendPrivateMessage !==
              "boolean" || privateMessagePermissions?.canSendPrivateMessage
          }
        />
      )}
    </div>
  );
}

ThreadControlUI.propTypes = {
  activeThread: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  deleteConversation: PropTypes.func.isRequired,
  isMutedByCurrentUser: PropTypes.bool.isRequired,
  isBlockedByCurrentUser: PropTypes.bool,
  privateMessagePermissions: PropTypes.object
};

const ThreadControl = connect(
  null,
  {
    deleteConversation
  }
)(ThreadControlUI);

export { ThreadControl, ThreadControlUI };
